import React, { useEffect, useState, useCallback } from 'react';
import api from '../../../api/axios';
import { UserCircleIcon, TrashIcon } from '@heroicons/react/24/outline';

const ProfileCustomers = () => {
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchCustomers = useCallback(async () => {
        try {
            setLoading(true);
            const res = await api.get('/crm/customers/profiles');
            setCustomers(res.data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { fetchCustomers(); }, [fetchCustomers]);

    if (loading) return <div className="p-4">Loading profile customers...</div>;

    return (
        <div className="bg-white shadow-md rounded-lg overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                    <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Profile Customer</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Owner</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Assigned Sevak</th>
                        <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase">Actions</th>
                    </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                    {customers.length > 0 ? customers.map((customer) => (
                        <tr key={customer.id}>
                            <td className="px-6 py-4">
                                <div className="text-sm font-medium text-gray-900">{customer.name}</div>
                                <div className="text-sm text-gray-500">{customer.slug}</div>
                            </td>
                            <td className="px-6 py-4 text-sm text-gray-700">{customer.owner_name}</td>
                            <td className="px-6 py-4 text-sm text-gray-700">{customer.assigned_admin_name}</td>
                            <td className="px-6 py-4 text-center space-x-4">
                                <button className="text-indigo-600 hover:text-indigo-900" title="View Details"><UserCircleIcon className="h-5 w-5" /></button>
                                <button className="text-red-600 hover:text-red-900" title="Delete Customer"><TrashIcon className="h-5 w-5" /></button>
                            </td>
                        </tr>
                    )) : (
                        <tr><td colSpan="4" className="text-center py-4 text-gray-500">No profile customers found.</td></tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default ProfileCustomers;